// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.

import { EnvironmentEnum } from "@app/core/helpers/enums/enums";

// The list of file replacements can be found in `angular.json`.
const REGIONS = {
  US_EAST_1: 'us-east-1',
  US_WEST_2: 'us-west-2'
}

/**
 * 0 is for dev env     
 * http://localhost:8092/v1/api/
 */
const stageApiUrl = 'https://podcast-backend.softobiz.net/v1/api/';
const localApiUrl = 'http://localhost:8092/v1/api/';
const ENV = EnvironmentEnum.stage;
const API = !Number(ENV) ? localApiUrl : stageApiUrl;

export const environment = {
  production: true,
  env: ENV,
  host: API,
  fbAppId: '1107834353001423',
  yt: {
    clientId: '229604634779-glcb65ditbr0q3anms31ku6nelkvv9ab.apps.googleusercontent.com',
    apiKey: 'AIzaSyCooymcnb-JWPYvABJR6VT0g4WkXjFttMc',
    clientUrl: 'https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest'
  },
  aws: {
    region: 'us-east-1',
    identityPoolId: 'us-east-1:24e83721-06d6-4d98-9929-e8a5b1412efa',
    s3: {
      bucket: 'boomcaster-dev',
      apiVersion: '2006-03-01',
      region: REGIONS.US_EAST_1,
      isAccelerate: false
    }
  },
  //stripePubKey: 'pk_test_51Hc0RCIm7fpSiAAZI4FUHBPheQ5P1WclzcUVl3j6T0O5h9csO1zFAmPKFlDGvg3u8etaNMWqh6yg91PmMuuDcNWb00FhHaywyd',
  logRocket: 'biopqh/bcaster',
  sentry: 'https://fbfa2caeb7f84a4bac8ab77d77059432@o432180.ingest.sentry.io/5384549',
  stripePubKey: 'pk_test_51IzwfTH11zgXX7Yuv8gElFvSBrkercJ1z66XtEOyw1MwPqBst5l7J0oEeDxIWeaPc2pj5IbdlK9XrlPUMryO6UL800cv6MI2Id',
  enableLiveChat: true,
  enableAudience: true,
  version: 1.01
};

/*
  *DEV:5544335  PD:5871955  5871955
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
